import { useRouter } from 'next/router';

import { isMobile } from '@zep/utils';

/**
 * query를 받아 결제 페이지로 이동합니다.
 */
export const useMoveToPaymentWithQuery = () => {
  const router = useRouter();

  return (query: string) => {
    if (isMobile()) {
      router.push(`/plan-payment?${query}`);
      return;
    }
    window.open(`/plan-payment?${query}`);
  };
};
